export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '颜卯科技',

    /** 公司名称 */
    name: '上海颜卯科技有限公司',
    /** 公司微信 */
    wechat: 'GZWjxxxt',
    /** 公司邮箱 */
    email: 'wjhsmarter@xx.com',
    /** 公司手机 */
    phone: '021-60410579',
    /** 公司电话 */
    tel: '021-60410579',
    /** 公司地址 */
    address: '上海市浦东新区浦三路3058号321室',
    /** 备案号 */
    keepOnRecordIcp: '沪ICP备20011236号-8',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 121.526896,
        latitude: 31.24022,
        title: '长青企业广场',
        address: '上海市浦东新区浦三路3058号321室'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js